import { render } from "./articleRight.vue?vue&type=template&id=67351cfc&scoped=true"
import script from "./articleRight.vue?vue&type=script&lang=js"
export * from "./articleRight.vue?vue&type=script&lang=js"

import "./articleRight.vue?vue&type=style&index=0&id=67351cfc&lang=scss&scoped=true"
import "./articleRight.vue?vue&type=style&index=1&id=67351cfc&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67351cfc"]])

export default __exports__